var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.48987 8.11097V2",
    stroke: "#272626",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2033 24.0474C13.1456 24.0474 13.475 22.6389 13.475 21.0373C13.5183 20.2709 13.7665 19.5302 14.1941 18.8928C14.6217 18.2553 15.2129 17.7445 15.9057 17.4139C16.4576 17.1797 16.917 16.7702 17.2126 16.2487C17.5083 15.7271 17.6238 15.1226 17.5413 14.5288V8.11108H1.50294V14.5288C1.42232 15.1224 1.53859 15.7261 1.83405 16.2472C2.1295 16.7684 2.58775 17.1782 3.13852 17.4139C3.83264 17.7439 4.42551 18.2543 4.85508 18.8916C5.28465 19.529 5.53505 20.27 5.58053 21.0373C5.58053 22.6389 5.88721 24.0474 7.85227 24.0474H11.2033Z",
    stroke: "#272626",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5432 8.11097V2",
    stroke: "#272626",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.48987 14.1765H13.5432",
    stroke: "#272626",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5922 27.1935C30.5922 25.7957 30.0371 24.4552 29.0487 23.4668C28.0603 22.4784 26.7197 21.9231 25.3219 21.9231C23.9241 21.9231 22.5835 22.4784 21.5951 23.4668C20.6067 24.4552 20.0513 25.7957 20.0513 27.1935V36.4849C20.0844 37.1969 19.9729 37.9082 19.7232 38.5757C19.4736 39.2433 19.0911 39.8533 18.599 40.3688C18.1069 40.8844 17.5152 41.2947 16.86 41.5751C16.2047 41.8554 15.4995 42 14.7868 42C14.0741 42 13.3686 41.8554 12.7133 41.5751C12.0581 41.2947 11.4665 40.8844 10.9743 40.3688C10.4822 39.8533 10.0998 39.2433 9.8501 38.5757C9.60045 37.9082 9.48897 37.1969 9.52204 36.4849V23.9904",
    stroke: "#272626",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlug);
export default __webpack_public_path__ + "static/media/plug.0fe333648a99e621372a13ea84411c27.svg";
export { ForwardRef as ReactComponent };